export function getNestedValue(obj: $TSFixMe, path: $TSFixMe) {
  if (typeof path === 'string') {
    return getNestedValue(obj, path.split('.'));
  }

  if (obj === undefined) {
    return undefined;
  }

  const [key, ...remaining] = path;
  if (key) {
    return getNestedValue(obj[key], remaining);
  }

  return obj;
}

// @ts-expect-error TS7023
export function setNestedValue(obj: $TSFixMe, path: $TSFixMe, value: $TSFixMe) {
  if (typeof path === 'string') {
    return setNestedValue(obj, path.split('.'), value);
  }

  const [key, ...remaining] = path;
  if (remaining.length > 0) {
    return {
      ...obj,
      [key]: setNestedValue(obj[key] || {}, remaining, value),
    };
  }

  return {
    ...obj,
    [key]: value,
  };
}
